import React from "react";
import "./MainContent.scss";
export default function MainContent({ children }) {
  return (
    <section
      className={`relative grid grid-cols-1 min-h-screen bg-slate-100 dark:bg-gray-900 main-content gap-4`}
    >
      {children}
    </section>
  );
}
